import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a table report view.
 * @extends JetView
 */
export default class tableReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        const cur_user = this.getParam('user', true); // Current user parameter

        return {
            rows: [
                {
                    id: 'preloader', // Preloader ID
                    cols: [
                        {
                            view: 'datatable', // Data table view
                            id: 'datatable', // Data table ID
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                // Column definitions
                                {
                                    id: 'Id', // Column ID
                                    header: _('ID Usuario'), // Column header
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Name', // Column ID
                                    header: _('Nombre Usuario'), // Column header
                                    width: 250, // Column width
                                    sort: 'string', // Sorting type
                                    hidden: !devConfig.getPermAction('sensitiveInformationNames', 'Add'), // Conditional visibility
                                },
                                {
                                    id: 'State', // Column ID
                                    header: _('Estado'), // Column header
                                    options: [
                                        // Dropdown options for the column
                                        { id: '', value: _('None') },
                                        { id: 'A', value: _('Activado') },
                                        { id: 'C', value: _('Cancelado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'CreatedLocalDate', // Column ID
                                    header: _('Fecha de creación'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'LastLoginLocalDate', // Column ID
                                    header: _('Fecha del ultimo logueo'), // Column header
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            on: {
                                // Event handlers
                                onItemDblClick: (id) => {
                                    // Double-click event
                                    window.location.href = '#!/top/customers?user=' + id + '/information'; // Redirect to user information
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: 0, // Load ahead configuration
                            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table instance.
     */
    init(grid) {
        grid = $$('datatable'); // Get the data table instance
        const cur_user = this.getParam('user', true); // Current user parameter
        var url = devConfig.geturlApi() + 'es/UserManagement/GetUsersAffiliates'; // API URL
        var filter = ''; // Filter string

        // Event listener for filtering user affiliates
        this.on(this.app, 'userAffiliates:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Filter query string

            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object values
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] != 'Date') {
                            // Handle other filters
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add filter to query
                        } else {
                            if (object[i][0] == 'Date') {
                                // Handle single date
                                var date = object[i][1].replace(' 00:00:00', ''); // Format date
                                string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter variable
            $$('filterPopup').hide(); // Hide filter popup
        });
    }
}

// FILE DOCUMENTED
